module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toast"
  }, [_vm._v("\n    " + _vm._s(_vm.toast.message) + "\n    " + _vm._s(_vm.toast.button) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-740bf0ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast.vue
// module id = 464
// module chunks = 2